import { Box, Divider, Typography } from '@mui/material';
import { mobileBreakpoint, useIsMobile } from '@uplift/hooks';
import { useCptCodesByIdsQuery } from '@uplift/queries';
import { Loader } from '@uplift/ui-v2';


export const DescriptionOfService: React.VFC<{ cptCodes: string[] }> = ({ cptCodes }) => {
  const isMobile = useIsMobile(mobileBreakpoint);
  const { data: codes, isLoading } = useCptCodesByIdsQuery(cptCodes);

  const primary = codes?.find((code) => code.codingType === 'primary');
  const addons = codes?.filter((code) => code.codingType === 'addon' || code.codingType === 'hybrid');

  if (!codes?.length) {
    return null;
  }

  return (
    <Box maxWidth={{ xs: '100%', sm: '316px' }}>
      {/* <Typography variant="body2" color="textPrimary" style={{ fontWeight: 600 }}>Description of Service</Typography> */}
      {isMobile
        ? (
          <>
            <Box px={2} py={1}>
              <Typography variant="h4" color="textPrimary">Description of Service</Typography>
            </Box>
            <Divider />
          </>
        )
        : (
          <Typography variant="body2" color="textPrimary" style={{ fontWeight: 600 }}>Description of Service</Typography>
        )}

      <Box p={{ xs: 2, sm: 0 }} bgcolor={{ xs: '#fff', sm: 'transparent' }}>
        {isLoading && <Loader height="140px" />}

        {primary && (
          <Box mt={1} display="flex" flexDirection="column" gap="4px">
            <Typography style={{ fontWeight: 450 }}>Primary</Typography>
            <Typography variant={isMobile ? 'body1' : 'body2'} color="textPrimary">{primary.code}: {primary.name}</Typography>
          </Box>
        )}

        {addons?.length > 0 && (
          <Box mt={2} display="flex" flexDirection="column" gap="4px">
            <Typography style={{ fontWeight: 450 }}>Add-ons</Typography>
            {addons.map((addon, index) => (
              <Typography key={index} variant={isMobile ? 'body1' : 'body2'} color="textPrimary">{addon.code}: {addon.name}</Typography>
            ))}
          </Box>
        )}
      </Box>
      {isMobile && <Divider />}
    </Box>
  );
};
